var Backbone, SupportDropDownModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

SupportDropDownModel = (function(superClass) {
  extend(SupportDropDownModel, superClass);

  function SupportDropDownModel() {
    return SupportDropDownModel.__super__.constructor.apply(this, arguments);
  }

  SupportDropDownModel.prototype.initialize = function() {
    return this.url = window.SUPPORTBASEURL + "/fetch?key=dropdowns&type=dropdowns&should_display_cms_content=" + experiments.shouldDisplayCMSContentForUS;
  };

  return SupportDropDownModel;

})(Backbone.Model);

module.exports = SupportDropDownModel;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUva3VtYXJyYS9uYXBpc3RyYW5vL2J1aWxkLzE1MDQ3NzgxNDM1MjYtNzYxNzcvcHJvZHVjdGlvbi0yMDE3LjA5LjA3XzA5LjU0L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC9tb2RlbHMvZHJvcGRvd25zLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2t1bWFycmEvbmFwaXN0cmFuby9idWlsZC8xNTA0Nzc4MTQzNTI2LTc2MTc3L3Byb2R1Y3Rpb24tMjAxNy4wOS4wN18wOS41NC9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvbW9kZWxzL2Ryb3Bkb3ducy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSw4QkFBQTtFQUFBOzs7QUFBQSxRQUFBLEdBQVcsT0FBQSxDQUFRLFVBQVI7O0FBRUw7Ozs7Ozs7aUNBQ0osVUFBQSxHQUFZLFNBQUE7V0FDVixJQUFDLENBQUEsR0FBRCxHQUFVLE1BQU0sQ0FBQyxjQUFSLEdBQXVCLGlFQUF2QixHQUF3RixXQUFXLENBQUM7RUFEbkc7Ozs7R0FEcUIsUUFBUSxDQUFDOztBQUk1QyxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
